import { render, staticRenderFns } from "./EasySetupPeoplePullout.vue?vue&type=template&id=52f53b92&scoped=true&"
import script from "./EasySetupPeoplePullout.vue?vue&type=script&lang=js&"
export * from "./EasySetupPeoplePullout.vue?vue&type=script&lang=js&"
import style0 from "./EasySetupPeoplePullout.vue?vue&type=style&index=0&id=52f53b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f53b92",
  null
  
)

export default component.exports